import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ConsumptionData from 'Components/ConsumptionData';

export default class Consumption extends React.Component {
  toggleConsumptionInfo = () => {
    this.props.setSharedState(
      'isAccessoryConsumptionInfoClosed',
      !this.props.sharedState.isAccessoryConsumptionInfoClosed
    );
  };

  render() {
    const { consumptionText, consumptionTextList, deeplinkId } = this.props;

    if (!consumptionText && (!consumptionTextList || consumptionTextList.length === 0)) {
      return null;
    }

    return (
      <Fragment>
        <ConsumptionData
          consumptionText={consumptionText ? [consumptionText] : consumptionTextList}
          deeplinkId={deeplinkId}
        />
      </Fragment>
    );
  }
}

Consumption.propTypes = {
  consumptionText: PropTypes.string,
  consumptionTextList: PropTypes.array,
  deeplinkId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
